import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookedJourneyDetail, IBookingComment, IBookingCommentRequestPayload } from "../../Orchestrator/Types/Index";
import { FMLM_BOOKING_JOURNEY_COMMENT_LEVEL, FMLM_BOOKING_JOURNEY_COMMENT_TYPE } from "./createBookingCommentAPI";

export async function updateBookingCommentAPI(bookingId: string, comment_id: string, comment: IBookedJourneyDetail): Promise<IApiResponse<IBookingComment>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.updateBookingComment(bookingId, comment_id)}`;

    const payload: IBookingCommentRequestPayload = {
        comment: JSON.stringify(comment),
        type: FMLM_BOOKING_JOURNEY_COMMENT_TYPE,
        level: FMLM_BOOKING_JOURNEY_COMMENT_LEVEL
    }

    return await apiRequest<IBookingComment>(endpoint, 'PATCH', {
        body: JSON.stringify(payload)
    });
}
